import React from "react";
import { Link } from "react-router-dom";
import { useContent } from "../context/ContentContext";
import { FacilityIcon } from "../lib/facilityIcons";
import PageHero from "../components/PageHero";

export default function Facilities() {
  const { content } = useContent();
  const fp = content?.facilities_page || {};
  const all = (content?.facilities || []).filter((f) => !f.hidden && f.label);
  const ordered = [...all.filter((f) => f.featured), ...all.filter((f) => !f.featured)];
  return (
    <div>
      <PageHero
        eyebrow="Facilities"
        title={fp.title || "Facilities & Amenities"}
        subtitle={fp.subtitle || "Everything you need for a restful, memorable mountain escape."}
        image={content?.page_heroes?.facilities?.image}
      />
      <section className="container-lux py-16" data-testid="facilities-page">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {ordered.map((f, i) => (
            <Link key={i} to={f.experience_id ? `/experiences?exp=${f.experience_id}` : `/facilities/${f.id || i}`} className={`block card-lux overflow-hidden hover:shadow-lg transition-shadow ${f.featured ? "ring-1 ring-gold/40" : ""}`} data-testid={`facility-card-${i}`}>
              {f.images && f.images[0] && <img src={f.images[0]} alt={f.label} className="h-44 w-full object-cover object-center" />}
              <div className="p-6">
                <div className="flex items-center gap-2 text-forest">
                  <FacilityIcon name={f.icon} size={20} className="text-rose" />
                  <h3 className="font-serif text-xl">{f.label}</h3>
                  {f.featured && <span className="ml-auto text-[10px] uppercase tracking-wide text-gold">Featured</span>}
                </div>
                {f.description && <p className="text-sm text-stone-500 mt-2 leading-relaxed">{f.description}</p>}
                {f.amenities?.length > 0 && (
                  <ul className="mt-3 flex flex-wrap gap-1.5">
                    {f.amenities.map((a, x) => <li key={x} className="text-[11px] bg-sand rounded-full px-2.5 py-1 text-forest">{a}</li>)}
                  </ul>
                )}
              </div>
            </Link>
          ))}
          {ordered.length === 0 && <p className="text-stone-400">Facilities coming soon.</p>}
        </div>
      </section>
    </div>
  );
}
